/*
 * @Author: zdx 3539255028@qq.com
 * @Date: 2022-06-01 09:51:28
 * @LastEditors: zdx 3539255028@qq.com
 * @LastEditTime: 2022-06-06 14:05:22
 * @FilePath: \jeecg-boot-v3\src\router\routes\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';

import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '/@/router/routes/basic';

import { mainOutRoutes } from './mainOut';
import { PageEnum } from '/@/enums/pageEnum';

const modules = import.meta.globEager('./modules/**/*.ts');

const routeModuleList: AppRouteModule[] = [];

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};

// export const LoginRoute: AppRouteRecordRaw = {};

export const GoAppRouter: AppRouteRecordRaw = {
  path: '/goApp',
  name: 'goApp',
  component: () => import('/@/layouts/default/goApp'),
  meta: {
    title: 'goApp',
  },
};

export const GoAppExternalRouter: AppRouteRecordRaw = {
  path: '/goAppExternal',
  name: 'goAppExternal',
  component: () => import('/@/layouts/default/goAppExternal'),
  meta: {
    title: 'goAppExternal',
  },
};

// Basic routing without permission
export const basicRoutes = [
  // LoginRoute,
  RootRoute,
  GoAppRouter,
  GoAppExternalRouter,
  ...mainOutRoutes,
  // // TODO: 临时路由 — 数据埋点页面，后续需从后端菜单管理配置，此条可删除
  // {
  //   path: '/do-back/dashboard/data_buried_point',
  //   name: 'DataBuriedPoint',
  //   component: () => import('/@/views/modules/shanshe/do_back/user_dashboard/data_buried_point/index'),
  //   meta: {
  //     title: '数据埋点',
  //   },
  // },
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
];
